import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue";
import _imports_0 from '../../../assets/images/icon1.png';
import _imports_1 from '../../../assets/images/icon2.png';
const _hoisted_1 = {
  class: "travelServe scenicspotdetailContainer"
};
const _hoisted_2 = {
  class: "container"
};
const _hoisted_3 = {
  class: "dtop"
};
const _hoisted_4 = {
  class: "content clearfix"
};
const _hoisted_5 = {
  class: "banner"
};
const _hoisted_6 = {
  key: 0,
  class: "label"
};
const _hoisted_7 = {
  class: "swiper-container swiperbox visibleitem",
  ref: "swipercontainer"
};
const _hoisted_8 = {
  class: "swiper-wrapper"
};
const _hoisted_9 = ["src"];
const _hoisted_10 = {
  class: "rightBox"
};
const _hoisted_11 = {
  class: "rightinnerbox"
};
const _hoisted_12 = {
  class: "title clearfix"
};
const _hoisted_13 = ["innerHTML"];
const _hoisted_14 = {
  class: "bottomBox"
};
const _hoisted_15 = {
  class: "viewspan"
};
const _hoisted_16 = {
  class: "starspan"
};
const _hoisted_17 = {
  class: "dmiddle clearfix"
};
const _hoisted_18 = {
  class: "jt middleitem"
};
const _hoisted_19 = {
  class: "jttxt"
};
const _hoisted_20 = {
  class: "opendate middleitem"
};
const _hoisted_21 = {
  class: "oul middleitem clearfix"
};
const _hoisted_22 = {
  key: 0
};
const _hoisted_23 = ["href"];
const _hoisted_24 = {
  key: 1
};
const _hoisted_25 = ["href"];
const _hoisted_26 = {
  key: 0,
  class: "imgcontainer"
};
const _hoisted_27 = ["href"];
const _hoisted_28 = ["src"];
const _hoisted_29 = {
  class: "dbttom"
};
const _hoisted_30 = {
  class: "fieldul clearfix"
};
const _hoisted_31 = {
  key: 0
};
const _hoisted_32 = {
  key: 1
};
const _hoisted_33 = {
  key: 2
};
const _hoisted_34 = {
  key: 3
};
const _hoisted_35 = {
  key: 4
};
const _hoisted_36 = {
  key: 5
};
const _hoisted_37 = {
  key: 6
};
const _hoisted_38 = {
  key: 7
};
const _hoisted_39 = {
  class: "dbcontent"
};
const _hoisted_40 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_View = _resolveComponent("View");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_Star = _resolveComponent("Star");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [$data.detail[8] !== '' ? (_openBlock(), _createElementBlock("span", _hoisted_6, [_createElementVNode("i", null, _toDisplayString($data.detail[8]), 1)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.detail.bannerList, (item, i) => {
    return _openBlock(), _createElementBlock("div", {
      class: "swiper-slide",
      key: i
    }, [_createElementVNode("img", {
      class: "imgcover",
      src: $options.setHttp(item.fileUrl)
    }, null, 8, _hoisted_9)]);
  }), 128))])], 512)]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("h2", null, _toDisplayString($data.detail[2]), 1), _createElementVNode("h3", null, [_createElementVNode("span", null, _toDisplayString($data.detail[19]), 1)])]), _createElementVNode("div", {
    class: "desc",
    innerHTML: $data.detail[12]
  }, null, 8, _hoisted_13)]), _createElementVNode("div", _hoisted_14, [_createElementVNode("span", _hoisted_15, [_createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_View)]),
    _: 1
  }), _createElementVNode("b", null, _toDisplayString($data.detail[15] === '' ? 0 : $data.detail[15]), 1)]), _createElementVNode("span", _hoisted_16, [_createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_Star)]),
    _: 1
  }), _createElementVNode("b", null, _toDisplayString($data.detail[15] === '' ? 0 : $data.detail[15]), 1)])])])])]), _createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_cache[0] || (_cache[0] = _createElementVNode("h4", null, "交通指南", -1)), _createElementVNode("div", _hoisted_19, _toDisplayString($data.detail[15]), 1)]), _createElementVNode("div", _hoisted_20, [_cache[1] || (_cache[1] = _createElementVNode("h4", null, "开放时间", -1)), _createElementVNode("div", null, _toDisplayString($data.detail[21]), 1)]), _createElementVNode("ul", _hoisted_21, [$data.detail[22] !== '' ? (_openBlock(), _createElementBlock("li", _hoisted_22, [_createElementVNode("a", {
    href: $data.detail[22],
    target: "_blank"
  }, [...(_cache[2] || (_cache[2] = [_createElementVNode("img", {
    class: "imgcover",
    src: _imports_0,
    alt: ""
  }, null, -1)]))], 8, _hoisted_23)])) : _createCommentVNode("", true), $data.detail[23] !== '' ? (_openBlock(), _createElementBlock("li", _hoisted_24, [_createElementVNode("a", {
    href: $data.detail[23],
    target: "_blank"
  }, [...(_cache[3] || (_cache[3] = [_createElementVNode("img", {
    class: "imgcover",
    src: _imports_1,
    alt: ""
  }, null, -1)]))], 8, _hoisted_25)])) : _createCommentVNode("", true)])]), $data.detail[24] !== '' ? (_openBlock(), _createElementBlock("div", _hoisted_26, [_createElementVNode("a", {
    href: $data.detail[24],
    target: "_blank"
  }, [_createElementVNode("img", {
    src: $data.gpimg,
    alt: ""
  }, null, 8, _hoisted_28)], 8, _hoisted_27)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_29, [_cache[12] || (_cache[12] = _createElementVNode("div", {
    class: "title"
  }, [_createElementVNode("span", null, "景点详情"), _createElementVNode("i")], -1)), _createElementVNode("ul", _hoisted_30, [$data.detail[26] !== '' ? (_openBlock(), _createElementBlock("li", _hoisted_31, [_cache[4] || (_cache[4] = _createElementVNode("label", null, "中文名称", -1)), _createElementVNode("span", null, _toDisplayString($data.detail[26]), 1)])) : _createCommentVNode("", true), $data.detail[30] !== '' ? (_openBlock(), _createElementBlock("li", _hoisted_32, [_cache[5] || (_cache[5] = _createElementVNode("label", null, "门票价格", -1)), _createElementVNode("span", null, _toDisplayString($data.detail[30]), 1)])) : _createCommentVNode("", true), $data.detail[27] !== '' ? (_openBlock(), _createElementBlock("li", _hoisted_33, [_cache[6] || (_cache[6] = _createElementVNode("label", null, "外文名称", -1)), _createElementVNode("span", null, _toDisplayString($data.detail[27]), 1)])) : _createCommentVNode("", true), $data.detail[28] !== '' ? (_openBlock(), _createElementBlock("li", _hoisted_34, [_cache[7] || (_cache[7] = _createElementVNode("label", null, "类别", -1)), _createElementVNode("span", null, _toDisplayString($data.detail[28]), 1)])) : _createCommentVNode("", true), $data.detail[36] !== '' ? (_openBlock(), _createElementBlock("li", _hoisted_35, [_cache[8] || (_cache[8] = _createElementVNode("label", null, "地点", -1)), _createElementVNode("span", null, _toDisplayString($data.detail[36]), 1)])) : _createCommentVNode("", true), $data.detail[32] !== '' ? (_openBlock(), _createElementBlock("li", _hoisted_36, [_cache[9] || (_cache[9] = _createElementVNode("label", null, "著名景点", -1)), _createElementVNode("span", null, _toDisplayString($data.detail[32]), 1)])) : _createCommentVNode("", true), $data.detail[33] !== '' ? (_openBlock(), _createElementBlock("li", _hoisted_37, [_cache[10] || (_cache[10] = _createElementVNode("label", null, "建议游玩时长", -1)), _createElementVNode("span", null, _toDisplayString($data.detail[33]), 1)])) : _createCommentVNode("", true), $data.detail[29] !== '' ? (_openBlock(), _createElementBlock("li", _hoisted_38, [_cache[11] || (_cache[11] = _createElementVNode("label", null, "适宜季节", -1)), _createElementVNode("span", null, _toDisplayString($data.detail[29]), 1)])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_39, [_createElementVNode("div", {
    class: "con",
    innerHTML: $data.detail[18]
  }, null, 8, _hoisted_40)])])])]);
}